import { AppBar, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import LicenseManage from "../License/LicenseManage";
import VUser from "../User/VUser";
import AppConfig from "../License/AppConfig";
import { useDispatch, useSelector } from "react-redux";
import { tabStyle, tabsStyle } from "../../Style/ManualStyle";
import { VALID_USER } from "../../Utils/constants/action-types";
import verasLogo from "./../../Assets/Images/verasLogo.png";
import "../../App.css";
import { Link } from "react-router-dom";
import "./ValidationForm.css";
import DefaultFooter from "../../Layout/DefaultFooter/DefaultFooter";

const ValidationForm = () => {
  const [tabsValue, setTabsValue] = useState(2);

  const { isValidKey, isConfigUser } = useSelector((state) => state.data);
  const { isUserValid } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   document.body.classList.add('validform');
  //   if (!isValidKey) {
  //     setTabsValue(0);
  //     return;
  //   } else {
  //     if (isValidKey && isUserValid && !isConfigUser) {
  //       setTabsValue(2);
  //       return;
  //     } else if (isValidKey && isConfigUser) {
  //       window.location = "/veras/#/";
  //       return;
  //     }
  //   }
  // }, [isValidKey, isUserValid, isConfigUser]);

  const validKey = (params) => {
    dispatch({
      type: VALID_USER,
      payload: params,
    });
    !params ? setTabsValue(1) : setTabsValue(2);
  };

  // const setTable = (e) => {
  //   console.log(e)
  //   setTabsValue(1)
  // }

  const handleChange = (event, newValue) => {
    setTabsValue(newValue);
};

  return (
  <div>
      <AppBar
        position="static"
        className="shadow-none"
        style={{ backgroundColor: "#242424" , height: '7vh'}}
      >
        <div className="d-flex shadow-none" style={{ marginTop: 'auto', marginBottom: 'auto' }}>
          <div className="col-md-2 bg-none validation-page-logo">
            <Link to={"/dashboard"}>
              <img
                className={"bc-logo"}
                src={verasLogo}
                height={40}
                alt={"logo"}
              />
            </Link>
          </div>
          <div className="col-md-8 before-login-menu" style={{padding: "0px"}}>
          <Tabs value={tabsValue} className="before-login-tabs" aria-label=""  style={tabsStyle}>
              <Tab label="License Validation" style={tabStyle} className="AdminTab" tabIndex={0}/>
              <Tab label="User Validation" style={tabStyle} className="AdminTab" tabIndex={1} />
              <Tab label="System Validation" style={tabStyle} className="AdminTab" tabIndex={2} />
            </Tabs>
          </div>
        </div>
      </AppBar>
      {tabsValue === 0 && <LicenseManage validKey={validKey} />}
      {tabsValue === 1 && <VUser />}
      {tabsValue === 2 && <AppConfig />}

      <DefaultFooter />
    </div>
  );
};

export default ValidationForm;